import React from 'react';
import ReactDOM from 'react-dom';
import { Field, formValueSelector,reduxForm } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../../components/LoadingSmall.js';


const validate = values => {
    const errors = {}
    if (!values.firstname) {
        errors.firstname = 'Required'
    }

    if (!values.lastname) {
        errors.lastname = 'Required'
    }

    if (!values.address) {
        errors.address = 'Required'
    }

    if (!values.invoice_email) {
        errors.invoice_email = 'Required'
    }

    if (!values.city) {
        errors.city = 'Required'
    }

    if (!values.zip) {
        errors.zip = 'Required'
    }

    if (!values.company_name) {
        errors.company_name = 'Required'
    }

    if (!values.year) {
        errors.year = 'Required'
    }

    if (!values.cvc) {
        errors.cvc = 'Required'
    }

    if (!values.month) {
        errors.month = 'Required'
    }

    if (!values.cardnumber) {
        errors.cardnumber = 'Required'
    }



    if (!values.password) {
        errors.password = 'Required'
    }else if (values.password.length < 6) {
        errors.password = 'Password must have minimum 6 characters'
    }

    return errors
}

const renderField = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (

    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type}/>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)


const select = ({ input, options,name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <select name={name} className="form-control" value={input.value} onChange={input.onChange}>
            {options.map((item,i) => {
                return <option key={i} value={item.value}>{item.label}</option>
            })}
        </select>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)



class BillingInformation extends React.Component {
    constructor(props) {
        super(props);
        this.calculatePrice = this.calculatePrice.bind(this);
    }

    years() {
        let years = [];
        const today = new Date().getFullYear();
        for(let i = today; i<=(parseInt(today)+10);i++) {
            years.push({
                'value':i,
                'label':i
            });
        }
        return years;
    }

    calculatePrice(price) {
        if(this.props.promo === false) {
            return price;
        }

        return parseInt(price)-parseInt(this.props.promo);
    }

    month() {
        let month = [];

        for(let i = 1; i<=12;i++) {
            month.push({
                'value':i,
                'label':i
            });
        }
        return month;
    }

    countries() {
        const country_list = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua &amp; Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas"
        ,"Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia &amp; Herzegovina","Botswana","Brazil","British Virgin Islands"
        ,"Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Cape Verde","Cayman Islands","Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica"
        ,"Cote D Ivoire","Croatia","Cruise Ship","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea"
        ,"Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia","Georgia","Germany","Ghana"
        ,"Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India"
        ,"Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kuwait","Kyrgyz Republic","Laos","Latvia"
        ,"Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Mauritania"
        ,"Mauritius","Mexico","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Namibia","Nepal","Netherlands","Netherlands Antilles","New Caledonia"
        ,"New Zealand","Nicaragua","Niger","Nigeria","Norway","Oman","Pakistan","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal"
        ,"Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Pierre &amp; Miquelon","Samoa","San Marino","Satellite","Saudi Arabia","Senegal","Serbia","Seychelles"
        ,"Sierra Leone","Singapore","Slovakia","Slovenia","South Africa","South Korea","Spain","Sri Lanka","St Kitts &amp; Nevis","St Lucia","St Vincent","St. Lucia","Sudan"
        ,"Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor L'Este","Togo","Tonga","Trinidad &amp; Tobago","Tunisia"
        ,"Turkey","Turkmenistan","Turks &amp; Caicos","Uganda","Ukraine","United Arab Emirates","United Kingdom","Uruguay","Uzbekistan","Venezuela","Vietnam","Virgin Islands (US)"
        ,"Yemen","Zambia","Zimbabwe"];

        let options = [];

        for(let i in country_list) {
            options.push({'label':country_list[i],'value':country_list[i]})
        }

        return options;
    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="panel panel-bordered" style={{border: "1px solid #e4eaec"}}>
                            <div className="panel-heading">
                                <h3 className="panel-title">Customer details</h3>
                            </div>
                            <div className="panel-body">

                                <div className="row">
                                    <div className="col-sm-12">
                                        <Field component={renderField} type="text" name="invoice_email" placeholder="Billing e-mail" title="Billing e-mail" className="form-control" />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6">
                                        <Field component={renderField} type="text" name="firstname" placeholder="John" title="Firstname" className="form-control" />
                                    </div>

                                    <div className="col-sm-6">
                                        <Field component={renderField} type="text" name="lastname" placeholder="Doe" title="Lastname" className="form-control" />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6">
                                        <Field component={renderField} type="text" name="company_name" placeholder="Acme Inc" title="Company name" className="form-control" />
                                    </div>

                                    <div className="col-sm-6">
                                        <Field component={renderField} type="text" name="vat" placeholder="133731337" title={this.props.country == 'Norway' ? 'Orgnumber (Norwegian)':'VAT number'} className="form-control" />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-12">
                                        <Field component={renderField} type="text" name="address" placeholder="Street address 1" title="Address" className="form-control" />
                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-sm-6">
                                        <Field component={renderField} type="text" name="zip" placeholder="12353" title="Zip" className="form-control" />
                                    </div>

                                    <div className="col-sm-6">
                                        <Field component={renderField} type="text" name="city" placeholder="Oslo" title="City" className="form-control" />
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="panel panel-bordered" style={{border: "1px solid #e4eaec"}}>
                            <div className="panel-heading">
                                <h3 className="panel-title">Payment</h3>
                                <div className="panel-actions col-sm-5 p-0">
                                    <div className="input-group">
                                        <input type="text" value={this.props.promo_code} onChange={this.props.handlePromoChange} className="form-control" placeholder="Promo code" />
                                        <span className="input-group-btn">
                                            <button type="button" onClick={this.props.applyPromo} className="btn btn-dark">Apply</button>
                                        </span>
                                    </div>
                                </div>

                            </div>
                            <div className="panel-body">

                            <div className="row">
                                <div className="col-sm-12">
                                    {this.props.errorMessage !== false ?
                                    <div className="alert dark alert-icon alert-danger alert-dismissible" role="alert">
                                    <i className="icon wb-close" aria-hidden="true"></i>
                                    {this.props.errorMessage}
                                    </div>
                                    :null}
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="table-active">
                                                <th>Package</th>
                                                <th>Description</th>
                                                <th>Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            Object.keys(this.props.p).map((key,i) => {
                                                let p = this.props.p[key];
                                                return (
                                                    <tr key={i}>
                                                        <td>{p.name} - <a href="javascript:void(0)" onClick={(e) => {e.stopPropagation(); this.props.changePackage()}}>(change)</a></td>
                                                        <td>
                                                            - Billed each month

                                                            {this.props.country == 'Norway' ? <p>- Priser uten mva</p>:''}

                                                        </td>
                                                        <td>
                                                            <strong>
                                                                {this.props.country == 'Norway' ?
                                                                    <p>{this.calculatePrice(p.amount)},- NOK</p>
                                                                    :
                                                                    <p>${this.calculatePrice(p.amount)}</p>
                                                                }
                                                            </strong></td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        {
                                            this.props.promo !== false ?
                                                <tr>
                                                    <td>Discount</td>
                                                    <td></td>
                                                    <td>{this.props.promo}</td>
                                                </tr>:null
                                        }
                                        <tr>
                                            <td>Total</td>
                                            <td></td>
                                            <td>{this.props.sumToPay()}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" name="cardnumber" placeholder="123412341234" title="Credit card number" className="form-control" />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-4">
                                    <Field component={select} options={this.month()} name="month" title="Expiry month" />
                                </div>

                                <div className="col-sm-4">
                                    <Field component={select} options={this.years()} name="year"  title="Expiry year" />
                                </div>

                                <div className="col-sm-4">
                                    <Field component={renderField} type="text" name="cvc" placeholder="123" title="CVC" className="form-control" />
                                </div>
                            </div>

                            <div className="row m-t-20">
                                <div className="col-sm-12">
                                    {
                                        this.props.isPaying
                                        ?
                                        <LoadingSmall />
                                        :
                                        <button type="submit" className="btn btn-dark btn-block">Confirm payment</button>
                                    }
                                </div>
                            </div>



                            </div>
                        </div>
                    </div>
                </div>

            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
  initialValues: {
  }
});
const selector = formValueSelector('BillingInformation');


// Decorate the form component
BillingInformation = reduxForm({
  form: 'BillingInformation',
  validate,
})(BillingInformation);

BillingInformation = connect(
  state => ({
    country:selector(state, 'country'),
    initialValues: {
        year: new Date().getFullYear(),
        month:new Date().getMonth(),

        country:'Norway',
      }
  })
)(BillingInformation)

export default BillingInformation;



// WEBPACK FOOTER //
// ./containers/settings/form/BillingInformation.js